<template>
  <div class="text-center" :class="textColor" >
    <div class="cursor-pointer flex items-center i18n-locale justify-center" @click="show=!show">
      <img class="h-4 w-5 inline" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2 inline">{{ getCurrentLocaleData.lang }} 
       <feather-icon
        icon="ChevronDownIcon" 
        class="icon-select-lang"/>
      </span>
    </div>
    <ul class="lang-list" v-if="show">
      <li v-for="lang in locales" class="lang-option" @click="updateLocale(lang)"><img class="h-4 w-5 mr-1 inline" :src="getImg(lang)" :alt="lang" /> &nbsp;{{getLanguage(lang).lang}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props:{
    textColor: String
  },
  data () {
    return {
      show: false,
      locales: process.env.VUE_APP_LANG_SUPPORTED.split(',')
    }
  },
  computed: {
    i18n_locale_img () {
      // Use below code to dynamically fetch image instead of if-else
      // NOTE: We used if-else because laravel throws error in 'yarn prod'.
      // If you are not using laravel + Vue, you can use below code to dynamically get image
      // return require(`@/assets/images/flags/${this.$i18n.locale}.png`)

      const locale = this.$i18n.locale
      if (locale === 'en')      return require('@/assets/images/flags/en.png')
      else if (locale === 'pt') return require('@/assets/images/flags/pt.png')
      else if (locale === 'fr') return require('@/assets/images/flags/fr.png')
      else if (locale === 'de') return require('@/assets/images/flags/de.png')
      else if (locale === 'es') return require('@/assets/images/flags/es.png')
      else return require('@/assets/images/flags/en.png')
    },
    getCurrentLocaleData () {
      const locale = this.$i18n.locale
      if (locale === 'en')      return { flag: 'us', lang: 'English'    }
      else if (locale === 'pt') return { flag: 'br', lang: 'Portuguese' }
      else if (locale === 'fr') return { flag: 'fr', lang: 'French'     }
      else if (locale === 'de') return { flag: 'de', lang: 'German'     }
      else if (locale === 'es') return { flag: 'es', lang: 'Español'    }
    }
  },
  methods: {
    updateLocale (locale) {
      this.$store.dispatch('setLang', locale)
      this.show = false
    },
    getLanguage (locale) {
      if (locale === 'en')      return { flag: 'us', lang: 'English'    }
      else if (locale === 'pt') return { flag: 'br', lang: 'Portuguese' }
      else if (locale === 'fr') return { flag: 'fr', lang: 'French'     }
      else if (locale === 'de') return { flag: 'de', lang: 'German'     }
      else if (locale === 'es') return { flag: 'es', lang: 'Español'    }
    },
    getImg (locale) {
      return require(`@/assets/images/flags/${locale}.png`)
    }
  }
}
</script>
